module.exports = __webpack_public_path__ + "src/assets/textures/petri/rag_lambert1_AO.jpg";